var _defs, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccelerateCycles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "      .cls-1 {        stroke: #fff;      }      .cls-1, .cls-2 {        fill: none;        stroke-linecap: round;        stroke-linejoin: round;        stroke-width: 1.3px;      }      .cls-2 {        stroke: #474b52;      }      .cls-3 {        fill: #00b5df;      }    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4.87,3.84c-1.82,0-3.29,1.48-3.29,3.29v29.8c0,1.82,1.48,3.29,3.29,3.29h37.24c1.82,0,3.29-1.48,3.29-3.29V7.13c0-1.82-1.48-3.29-3.29-3.29H4.87Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 40.61,
    y1: 12,
    x2: 6.36,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 39.11,
    y1: 17.37,
    x2: 35.89,
    y2: 17.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 32.01,
    y1: 17.37,
    x2: 28.79,
    y2: 17.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 24.9,
    y1: 17.37,
    x2: 21.68,
    y2: 17.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 39.11,
    y1: 22.74,
    x2: 35.89,
    y2: 22.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 32.01,
    y1: 22.74,
    x2: 28.79,
    y2: 22.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 24.9,
    y1: 22.74,
    x2: 21.68,
    y2: 22.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 17.79,
    y1: 22.74,
    x2: 14.57,
    y2: 22.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 10.69,
    y1: 22.74,
    x2: 7.47,
    y2: 22.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 39.11,
    y1: 28.1,
    x2: 35.89,
    y2: 28.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 32.01,
    y1: 28.1,
    x2: 28.79,
    y2: 28.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 24.9,
    y1: 28.1,
    x2: 21.68,
    y2: 28.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 17.79,
    y1: 28.1,
    x2: 14.57,
    y2: 28.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 10.69,
    y1: 28.1,
    x2: 7.47,
    y2: 28.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 24.9,
    y1: 33.47,
    x2: 21.68,
    y2: 33.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 17.79,
    y1: 33.47,
    x2: 14.57,
    y2: 33.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 10.69,
    y1: 33.47,
    x2: 7.47,
    y2: 33.47
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 9.08,
    y1: 1.51,
    x2: 9.08,
    y2: 6.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 23.48,
    y1: 1.51,
    x2: 23.48,
    y2: 6.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 37.89,
    y1: 1.51,
    x2: 37.89,
    y2: 6.17
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 39.11,
    cy: 38.79,
    r: 9.77
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "36.52 38.79 39.11 38.79 39.11 35.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.11,32.16c-3.66,0-6.63,2.98-6.63,6.63s2.97,6.63,6.63,6.63h.01c3.66,0,6.63-2.98,6.63-6.63s-2.98-6.63-6.63-6.63Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 39.11,
    y1: 33.88,
    x2: 39.11,
    y2: 33.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 39.11,
    y1: 44.5,
    x2: 39.11,
    y2: 43.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 34.86,
    y1: 36.34,
    x2: 34.17,
    y2: 35.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 44.06,
    y1: 41.65,
    x2: 43.36,
    y2: 41.24
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 34.86,
    y1: 41.24,
    x2: 34.17,
    y2: 41.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 44.06,
    y1: 35.94,
    x2: 43.36,
    y2: 36.34
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccelerateCycles);
export default __webpack_public_path__ + "static/media/Accelerate_Cycles.19a631d7c4fa8c588150df5774312402.svg";
export { ForwardRef as ReactComponent };